import "./Media.css";
import { GetArrayDataCollectionList } from "../../../utils/arrayHelperList";
import React from "react";

function getClassName(dataID: number, Target: number): string {
  if (dataID === 0) return "header-icon-13";
  if (dataID === 1) return "icon-color header-icon-" + Target;
  return "";
}

export function renderRowTableRowFirstWhenContentIsZero(
  rowContent,
  row,
  rowID,
  userPreference,
) {
  const Target = userPreference.Id;

  if (rowContent[2] === "0") {
    return (
      <React.Fragment>
        {" "}
        {GetArrayDataCollectionList(row).map(
          (val, rowID_row) =>
            rowID_row !== 2 && (
              <td style={{ color: "#7C6617", textAlign: "center" }} key={val.dataID}>
                {val.Data !== "" && (
                  <>
                    <i
                      className={getClassName(val.dataID, Target)}
                      style={{
                        fontSize: "12px",
                        left: "-5px",
                        position: "relative",
                        color: "#c9a404",
                      }}
                    />
                    {rowID === 0 && val.dataID === 0 ? (
                      <span className="media_spanBar">[</span>
                    ) : null}
                    <span translate="no">{val.Data.split("-")[0]} </span>
                    <br />
                    <span translate="no">{val.Data.split("-")[1]}</span>
                  </>
                )}
              </td>
            )
        )}
      </React.Fragment>
    );
  } else {
    return renderRowTableRowFirstWhenContentIsNotZero(
      rowContent,
      row,
      rowID,
      userPreference,
    );
  }
}

export function renderRowTableRowFirstWhenContentIsNotZero(
  rowContent,
  row,
  rowID,
  Target
) {
  if (rowContent[2] !== "0") {
    return (
      <React.Fragment>
        {GetArrayDataCollectionList(row).map((val, rowID_row) =>
          renderRowTableRowFirstWhenContentIsNotZeroForIndexEqualZero(
            rowID_row,
            rowID,
            val,
            Target
          )
        )}
      </React.Fragment>
    );
  }
  return <></>;
}

export function renderRowTableRowFirstWhenContentIsNotZeroForIndexEqualZero(
  rowID_row,
  rowID,
  val,
  Target
) {
  if (rowID_row === 0) {
    return (
      <td style={{ color: "white", textAlign: "center" }} key={val.dataID}>
        {rowID === 0 && val.dataID === 0 ? (
          <span className="media_spanBar">[</span>
        ) : (
          <></>
        )}
        <span translate="no">{val.Data.split("-")[0]}</span>
        <br />
        <span translate="no">{val.Data.split("-")[1]}</span>
      </td>
    );
  } else if (rowID_row === 1) {
    return renderRowTableRowFirstWhenContentIsNotZeroForIndexEqualOne(
      rowID_row,
      rowID,
      val,
      Target
    );
  } else {
    return <></>;
  }
}

export function renderRowTableRowFirstWhenContentIsNotZeroForIndexEqualOne(
  rowID_row,
  rowID,
  val,
  Target
) {
  if (rowID_row === 1) {
    return (
      <td
        style={{
          textAlign: "center",
          borderRight: "1px solid #000",
          color: "black",
        }}
      >
        <p style={{ margin: "0px", marginRight: "8px" }}>
          <i
            className={"header-icon-" + Target.Id}
            style={{ marginRight: "3px", fontSize: "12px" }}
          ></i>
          <span style={{ color: "white" }}>{val.Data}</span>
        </p>
      </td>
    );
  }
  return <></>;
}
export function validAudienceMedia(audienceMedia: any, audienceMediaFirstTable): boolean {
  return (
    audienceMedia !== undefined &&
    audienceMedia.length > 0 &&
    audienceMediaFirstTable !== undefined &&
    audienceMediaFirstTable.length > 0
  );
}
export function processAudienceMedia(audienceMedia, audienceMediaFirstTable): string[][] {
  let arrMediaResult: string[][] = [];
  try {

    for (let i = 0; i < audienceMedia.length; i += 2) {
      let row = audienceMedia[i];
      let rowDep = audienceMedia[i + 1];
      let arr: string[] = [];

      for (let j = 0; j < row.length; j++) {
        arr.push(row[j] + "|" + rowDep[j]);
      }
      let typeMed = audienceMediaFirstTable[Math.ceil(i / 2)][2];
      arr.push(typeMed);
      arrMediaResult.push(arr);
    }
  } catch (e) {
    return []; 
  }
  return arrMediaResult;
}